import { APP_ROUTES } from 'shared/constants';
import { FeatureFlagKey, Tenant } from 'shared/types/tenant';

export interface NavigationTab {
    id: string;
    path: string;
    requiresFullAccess: boolean;
    requiresFeature?: FeatureFlagKey;
    requiresFeatureDisabled?: FeatureFlagKey;
    isNew?: boolean;
}

export const allTabs: NavigationTab[] = [
    // todo: to be implemented
    // { 
    //     id: 'ai-assistant', 
    //     path: APP_ROUTES.aiAssistant, 
    //     requiresFullAccess: true 
    // },
    {
        id: 'opportunities', 
        path: APP_ROUTES.candidateOffers, 
        requiresFullAccess: false 
    },
    { 
        id: 'jobPreferences', 
        path: APP_ROUTES.preferences,
        requiresFullAccess: false,
        requiresFeature: 'CandidatesJobPreferences'
    },
    { 
        id: 'requestForOpportunities', 
        path: APP_ROUTES.requestForOpportunities,
        requiresFullAccess: false,
        requiresFeatureDisabled: 'CandidatesJobPreferences'
    },
    { 
        id: 'availability', 
        path: APP_ROUTES.candidateAvailability(''), 
        requiresFullAccess: false 
    },
    { 
        id: 'profile', 
        path: APP_ROUTES.profile,
        requiresFullAccess: false,
        isNew: true
    },
    { 
        id: 'my-jobs', 
        path: APP_ROUTES.myJobs,
        requiresFullAccess: false,
        isNew: true
    }
];

export function getVisibleTabs(hasFullAccess: boolean, tenant: Tenant): NavigationTab[] {
    return allTabs.filter(tab => 
        (hasFullAccess || !tab.requiresFullAccess) &&
        (!tab.requiresFeature || Boolean(tenant.featuresEnabled?.[tab.requiresFeature])) &&
        (!tab.requiresFeatureDisabled || !tenant.featuresEnabled?.[tab.requiresFeatureDisabled])
    );
}
